import type { Popup } from 'popups/Popup';
import type { Bounds, Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { NotificationPermissionPopupLayout } from '../../../../../layouts/popups/NotificationPermissionPopupLayout';

export class NotificationPermissionPopup implements Popup {
  private readonly layout = new NotificationPermissionPopupLayout();

  public readonly root: Container = this.layout.root;

  public readonly initialBounds: Bounds = this.root.getLocalBounds();

  public readonly onEvent = new Signal<(event: string) => void>();

  constructor() {
    this.layout.cancelButton.onpointerdown = (): void => {
      this.onEvent.emit('cancel');
    };

    this.layout.okayButton.root.onpointerdown = (): void => {
      this.onEvent.emit('okay');
    };
  }
}